import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-right align-self-end" }
const _hoisted_2 = {
  class: "btn-group mr-1",
  role: "group"
}
const _hoisted_3 = {
  class: "btn-group mr-1",
  role: "group"
}
const _hoisted_4 = {
  title: "Enterprise Plan",
  class: "btn btn-outline-secondary",
  style: {"padding":"0.7em 1em"}
}
const _hoisted_5 = {
  title: "Back to Portfolio Plans",
  class: "btn btn-outline-secondary",
  style: {"padding":"0.7em 1em"}
}

import { computed, shallowReactive } from 'vue';
    import { useRoute } from 'vue-router';
    import SelectorDialog from '@Quest/PortfolioScenarios/Components/SelectorDialog.vue';
    import PortfolioScenarioEditor from "@Quest/PortfolioScenarios/Components/PortfolioScenarioEditor.vue";
    import { SelectorDialogViewModel } from "@Quest/PortfolioScenarios/Components/SelectorDialog";
    import { PortfolioScenarioEditorViewModel } from "@Quest/PortfolioScenarios/Components/PortfolioScenarioEditor";

    // props
    
export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioScenarioNavigation',
  props: {
    portfolioId: {},
    corporateScenarioUrl: {}
  },
  emits: ["selector-opened", "settings-opened", "selected", "scenario-created", "scenario-updated"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    // emits
    const emit = __emit;

    const route = useRoute();
    const currentPath = computed(() => route.path)

    // route-derived values
    const workspaceId = computed(() => Number(route.params?.workspaceId ?? 0));
    const tchProjectId = computed(() => Number(route.params?.tchProjectId ?? 0));
    const scenarioId = computed(() => String(route.params?.scenarioId ?? ''));

    const selectorDialog = shallowReactive(new SelectorDialogViewModel());
    const portfolioScenarioEditor = shallowReactive(new PortfolioScenarioEditorViewModel());

    function getButtonClass(path: string): string
    {
        const routePrefix = `/portfolio-plan/${path}/`;

        return currentPath.value.startsWith(routePrefix)
            ? 'btn btn-secondary'
            : 'btn btn-outline-secondary';
    }

    function showSelectorDialog()
    {
        emit('selector-opened');

        selectorDialog.show(
            workspaceId.value,
            props.portfolioId,
            scenarioId.value
        );
    }

    function showScenarioEditor()
    {
        emit('settings-opened');

        portfolioScenarioEditor.showEditor(
            workspaceId.value,
            props.portfolioId,
            scenarioId.value
        );
    }

    function onSelected(result: any)
    {
        emit('selected', result)
    }

    function onScenarioCreated(id: string)
    {
        emit('scenario-created', id)
    }

    function onScenarioUpdated(id: string)
    {
        emit('scenario-updated', id)
    }


return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioScenarioEditor, {
      viewModel: _unref(portfolioScenarioEditor),
      onScenarioCreated: onScenarioCreated,
      onScenarioUpdated: onScenarioUpdated
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(SelectorDialog, {
      viewModel: _unref(selectorDialog),
      onSelected: onSelected
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        title: "Open Selector (AI Assistant)",
        class: "btn btn-success mr-1",
        style: {"padding":"0.7em 1em"},
        onClick: showSelectorDialog
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "fa-solid fa-robot fa-lg mr-1" }, null, -1 /* CACHED */),
        _createTextVNode(" Selector ", -1 /* CACHED */)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createElementBlock("a", {
          title: "Project Settings",
          class: _normalizeClass(getButtonClass('projects')),
          style: {"padding":"0.7em 1em"}
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "fa-solid fa-table fa-lg" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_sanitizedHref, `/#/portfolio-plan/projects/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}`]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          title: "Project Selection",
          class: _normalizeClass(getButtonClass('selection')),
          style: {"padding":"0.7em 1em"}
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fa-solid fa-list-check fa-lg" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_sanitizedHref, `/#/portfolio-plan/selection/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}`]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          title: "Project Schedule",
          class: _normalizeClass(getButtonClass('schedule')),
          style: {"padding":"0.7em 1em"}
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fa-regular fa-calendar fa-lg" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_sanitizedHref, `/#/portfolio-plan/schedule/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}`]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          title: "Project Review",
          class: _normalizeClass(getButtonClass('review')),
          style: {"padding":"0.7em 1em"}
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "fa-solid fa-database fa-lg" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_sanitizedHref, `/#/portfolio-plan/review/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}`]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          title: "Project Approval",
          class: _normalizeClass(getButtonClass('approval')),
          style: {"padding":"0.7em 1em"}
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "fa-solid fa-pen-nib fa-lg" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_sanitizedHref, `/#/portfolio-plan/approval/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}`]
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("a", {
        title: "Profit & Loss Report",
        class: _normalizeClass(["mr-1", getButtonClass('pnl')]),
        style: {"padding":"0.7em 2em"}
      }, [...(_cache[6] || (_cache[6] = [
        _createTextVNode(" P&L ", -1 /* CACHED */)
      ]))], 2 /* CLASS */)), [
        [_directive_sanitizedHref, `/#/portfolio-plan/pnl/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}`]
      ]),
      _createElementVNode("button", {
        title: "Portfolio Plan Settings",
        class: "btn btn-outline-secondary mr-1",
        style: {"padding":"0.7em 1em"},
        onClick: showScenarioEditor
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("i", { class: "fa fa-lg fa-cog" }, null, -1 /* CACHED */)
      ]))]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("i", { class: "fa-solid fa-sitemap fa-lg" }, null, -1 /* CACHED */)
        ]))])), [
          [_directive_sanitizedHref, __props.corporateScenarioUrl]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("i", { class: "fa-solid fa-door-open fa-lg" }, null, -1 /* CACHED */)
        ]))])), [
          [_directive_sanitizedHref, `/#/portfolio/plans/${workspaceId.value}/${tchProjectId.value}`]
        ])
      ])
    ])
  ]))
}
}

})